import axiosInstance from '../axiosInstance';

//CRUD Functions
// const getAll = async () => {
//   const collectionRef = collection(store, 'venues');
//   const snapshot = await getDocs(collectionRef);
//   const venues = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//   return venues;
// };

const getAll = async () => {
  return axiosInstance.get('/venue').then((response) => {
    return response.data;
  });
};

const getByUserId = async (userId) => {
  return axiosInstance.get(`/venue/user/${userId}`).then((response) => {
    return response.data;
  });
};

const getById = async (id) => {
  return axiosInstance.get(`/venue/${id}`).then((response) => {
    return response.data;
  });
};

const save = async (venue) => {
  return axiosInstance.post('/venue', venue).then((response) => {
    return response.data;
  });
};

const update = async (id, venue) => {
  return axiosInstance.put('/venue', { ...venue, id }).then((response) => {
    return response.data;
  });
};

const remove = async (id) => {
  return axiosInstance.delete(`/venue/${id}`).then((response) => {
    return response.data;
  });
};

const importVenues = async () => {
  return axiosInstance.post('/venue/import').then((response) => {
    return response.data;
  });
};

const venueService = { getById, getAll, getByUserId, save, update, remove, importVenues };

export default venueService;
